
import { common } from './common/en';
import { products } from './products/en';
import { pricing } from './pricing/en';
import { solutions } from './solutions/en';

export const en = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
